class NumberInput {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-amount-input="scope"]',
			minusBtn: '[data-amount-input="minus"]',
			plusBtn: '[data-amount-input="plus"]',
			input: '[data-amount-input="input"]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		$(document).off('.amount')
			.on('click.amount', this.config.minusBtn, this.changeAmount.bind(this))
			.on('click.amount', this.config.plusBtn, this.changeAmount.bind(this));
	}

	changeAmount(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		let $scope = $button.closest(this.config.scope);
		let $input = $scope.find(this.config.input);
		let isNegative = $button.is(this.config.minusBtn);

		if (!$input.is('input')) {
			return;
		}

		$input[0][isNegative ? 'stepDown' : 'stepUp']();
		$input.trigger('change');
	}
}

export default NumberInput;